<template>
  <div class="right_col" role="main">
    <Search ref="search" />
    <div class="col-md-12">
      <div class="x_panel">
        <div class="x_content">
          <TabNav />
          <div class="tab-content" id="myTabContent">
            <div
              class="row"
              style="
                display: flex;
                align-items: center;
                margin-top: 1rem;
                margin-bottom: 1rem;
              "
            >
              <div class="col-md-1">
                <el-select v-model="npp" @change="onNpp">
                  <el-option
                    v-for="npp in [10, 25, 50, 100]"
                    :key="npp"
                    :label="npp"
                    :value="npp"
                  ></el-option>
                </el-select>
              </div>
              <div v-if="vx_activeTab === 'instant'" class="col-md-6">
                <el-radio-group v-model="pick" @input="onRadio">
                  <el-radio
                    v-for="pick in PICKS"
                    :key="pick.id"
                    :label="pick.id"
                  >
                    <el-tooltip
                      v-if="pick.hover"
                      class="item"
                      effect="dark"
                      :content="pick.hover"
                      placement="top-start"
                    >
                      <span>{{ pick.title }}</span>
                    </el-tooltip>
                    <span v-else>{{ pick.title }}</span>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
            <!--立即單-->
            <Instant />
            <!--路招單-->
            <Road />
            <!--預約前派單-->
            <ReserveBefore @openModal="openModal" />
            <!--預約後派單-->
            <ReserveAfter @showReserveAfterBill="showReserveAfterBill" />
            <!--機場預約-->
            <Airport @showAirportTransfer="showAirportTransfer" />
          </div>
        </div>
      </div>
    </div>
    <ReserveModal ref="reserveModal" />
    <AirportModel ref="airportModal" />
  </div>
</template>

<script>
import { reqServiceStaff } from '@/api/transaction'
import { mapState, mapMutations, mapActions } from 'vuex'
import { Notification } from 'element-ui'
import { instantPick } from '@/constants/select'
import { driverReceived } from '@/constants/driver'
import DateSelect from '@/components/tool/DateSelect'
import ReserveModal from '@/components/reserveModal'
import AirportModel from '@/components/airportDetailModel'
import {
  Search,
  TabNav,
  Instant,
  Road,
  ReserveBefore,
  ReserveAfter,
  Airport,
} from './components'

export default {
  name: 'TransactionList',
  components: {
    Search,
    TabNav,
    DateSelect,
    ReserveModal,
    AirportModel,
    Instant,
    Road,
    ReserveBefore,
    ReserveAfter,
    Airport,
  },
  data() {
    return {
      npp: 25,
      pick: 0,
      isAvailableOpt: false,
      loader: null,
      driverReceivedInfo: this.getInitDriverReceivedInfo(),
    }
  },
  methods: {
    ...mapActions('transaction', {
      vx_fetchList: 'fetchList',
    }),
    ...mapActions('reserveModal', {
      vx_fetchServiceList: 'fetchServiceList',
    }),
    ...mapMutations('transaction', {
      vx_setPick: 'setPick',
      vx_setRule: 'setRule',
      // set currentPage
      vx_setInstantPagingCurrentPage: 'setInstantPagingCurrentPage',
      vx_setRoadPagingCurrentPage: 'setRoadPagingCurrentPage',
      vx_setReserveBeforePagingCurrentPage: 'setReserveBeforePagingCurrentPage',
      vx_setReserveAfterPagingCurrentPage: 'setReserveAfterPagingCurrentPage',
      vx_setAirportTransferPagingCurrentPage:
        'setAirportTransferPagingCurrentPage',
      // set npp
      vx_setInstantPagingNpp: 'setInstantPagingNpp',
      vx_setRoadPagingNpp: 'setRoadPagingNpp',
      vx_setReserveBeforePagingNpp: 'setReserveBeforePagingNpp',
      vx_setReserveAfterPagingNpp: 'setReserveAfterPagingNpp',
      vx_setAirportTransferPagingNpp: 'setAirportTransferPagingNpp',
    }),
    /* 預約單modal */
    ...mapMutations('reserveModal', {
      vx_setOpenAt: 'setOpenAt',
      vx_setModalId: 'setId',
      vx_mergeBillInfoFromList: 'mergeBillInfoFromList',
    }),
    ...mapActions('reserveModal', {
      vx_fetchOrderDetail: 'fetchOrderDetail',
    }),
    onRadio() {
      this.vx_setPick(this.pick)
      this.vx_setInstantPagingCurrentPage(1)
      this.vx_fetchList()
    },
    onNpp() {
      if (this.vx_activeTab === 'instant') {
        this.vx_setInstantPagingNpp(this.npp)
        this.vx_setInstantPagingCurrentPage(1)
      } else if (this.vx_activeTab === 'road') {
        this.vx_setRoadPagingNpp(this.npp)
        this.vx_setRoadPagingCurrentPage(1)
      } else if (this.vx_activeTab === 'reserveBefore') {
        this.vx_setReserveBeforePagingNpp(this.npp)
        this.vx_setReserveBeforePagingCurrentPage(1)
      } else if (this.vx_activeTab === 'reserveAfter') {
        this.vx_setReserveAfterPagingNpp(this.npp)
        this.vx_setReserveAfterPagingCurrentPage(1)
      } else if (this.vx_activeTab === 'airport') {
        this.vx_setAirportTransferPagingNpp(this.npp)
        this.vx_setAirportTransferPagingCurrentPage(1)
      }
      this.vx_fetchList()
    },
    getInitDriverReceivedInfo() {
      return driverReceived
    },
    clearDriverReceivedInfo() {
      this.driverReceivedInfo = this.getInitDriverReceivedInfo()
    },
    async openModal(id) {
      try {
        this.vx_setModalId(id)
        await this.vx_fetchOrderDetail()
        this.$refs.reserveModal.openModal()
      } catch (e) {
        console.error(e)
        Notification({
          title: '網路不穩定請在操作一次',
          type: 'error',
        })
      }
    },
    async showReserveAfterBill(id) {
      // 沒有引入customerServiceModal，但暫留
      $('#customerServiceModal').modal({ backdrop: 'static', keyboard: true })
      try {
        this.loader = this.$loading.show()
        const { result } = await reqServiceStaff(id)
        this.customerServiceList = result.list
      } catch (e) {
        console.error(e)
      } finally {
        this.loader.hide()
      }
    },

    async showAirportTransfer(id) {
      try {
        let matched = null
        if (this.vx_airportTransferList && this.vx_airportTransferList.length) {
          matched = this.vx_airportTransferList.find(
            (item) => item.billInfo && item.billInfo.orderId === id,
          )
        }
        this.vx_setOpenAt('叫車紀錄總查詢')
        this.vx_setModalId(id)
        await this.vx_fetchOrderDetail()
        if (matched) {
          this.vx_mergeBillInfoFromList({
            billInfo: matched.billInfo || {},
            driverInfo: matched.driverInfo || {},
          })
        }
        this.$refs.airportModal.openModal()
      } catch (e) {
        console.error(e)
        Notification({
          title: '網路不穩定請在操作一次',
          type: 'error',
        })
      }
    },
    updateNpp(activeTab) {
      if (activeTab === 'instant') {
        this.npp = this.vx_instantPaging.npp
      } else if (activeTab === 'road') {
        this.npp = this.vx_roadPaging.npp
      } else if (activeTab === 'reserveBefore') {
        this.npp = this.vx_reserveBeforePaging.npp
      } else if (activeTab === 'reserveAfter') {
        this.npp = this.vx_reserveAfterPaging.npp
      } else if (activeTab === 'airport') {
        this.npp = this.vx_airportTransferPaging.npp
      }
    },
  },
  computed: {
    ...mapState('transaction', {
      vx_activeTab: 'activeTab',
      vx_instantPaging: 'instantPaging',
      vx_roadPaging: 'roadPaging',
      vx_reserveBeforePaging: 'reserveBeforePaging',
      vx_reserveAfterPaging: 'reserveAfterPaging',
      vx_airportTransferPaging: 'airportTransferPaging',
      vx_airportTransferList: 'airportTransferList',
    }),
    ...mapState('reserveModal', {
      vx_modalBillInfo: 'billInfo',
    }),
  },
  created() {
    this.PICKS = instantPick
    this.unwatch = this.$store.watch(
      (state) => state.transaction.activeTab,
      (newActiveTab) => {
        this.updateNpp(newActiveTab)
        // 如果是路招單或預約後派單，設置 rule 為 0
        if (newActiveTab === 'road' || newActiveTab === 'reserveAfter') {
          this.vx_setRule(0)
        }
        this.vx_fetchList()
      },
    )
  },
  mounted() {
    this.vx_fetchList()
    this.vx_fetchServiceList()
    this.vx_setOpenAt('叫車紀錄總查詢')
    this.$refs.search.onSearch()
  },
  beforeDestroy() {
    this.unwatch()
  },
}
</script>

<style scoped>
.el-radio-group > .el-radio {
  font-weight: 700;
  color: #73879c;
}

.el-radio-group > .el-radio > .el-radio__label {
  font-size: 1.6rem;
}

.el-radio-group > .el-radio > .el-radio__input > .el-radio__inner {
  font-size: 1.6rem;
  border: 1px solid #73879c;
}
</style>



// WEBPACK FOOTER //
// src/pages/transaction/TransactionList.vue